import { z } from 'zod';

export const taskCreationSearchParamsSchema = z.object({
  escola: z.number().optional(),
});

export type TaskCreationSearchParams = z.infer<typeof taskCreationSearchParamsSchema>;
